<template>
  <div style="overflow: hidden" class="index">
    <div v-html="infoData.content"></div>
  </div>
</template>
<script>
import { doPost, doGet } from "../common/HttpHelper.js";
import { httpConfig } from "../common/config.js";
import dialog from "../common/dialog.vue";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";

export default {
  name: "HelloWorld",
  components: {
    Dialog: dialog,
    videoPlayer
  },
  data() {
    return {
      infoData: ""
    };
  },
  mounted() {
    this.getData(40);
  },
  methods: {
    getData(id) {
      var that = this;
      doGet(
        httpConfig.infoDetails.getDataUrl,
        { id: id },
        function(res) {
          that.infoData = res;
        },
        function(res) {}
      );
    }
  }
};
</script>
<style scoped>
@import "../../assets/css/index";
</style>



// WEBPACK FOOTER //
// src/components/page/index.vue